import { UserId } from '@shared/types/users.ts';

export const getCampaignListFiltersStorageKey = (userId: UserId): string => `${userId}-campaign-list-filters`;
